import { connect } from 'react-redux'
import { toggleDimensions } from '../../redux/actions'

@connect(state => ({
  dimensionsDebug: state.UI.dimensionsDebug
}), {
  doToggleDimensions: toggleDimensions
})
class UI extends React.Component {
  /**
   * Toggles the dimensionsZone component on or off.
   * @constructor
   */
  ToggleDimensions = () => {
    return () => this.props.doToggleDimensions()
  }

  render() {
    const { dimensionsDebug } = this.props

    return (
      <div id="UI">
        <div className="devSelector">
          <input type="checkbox" checked={dimensionsDebug} onChange={this.ToggleDimensions()}
            style={{ width: '25px', height: '25px', cursor: 'pointer' }} id="dimensionsButton" />
          <label style={{ marginLeft: 10, verticalAlign: 7, cursor: 'pointer' }} htmlFor="dimensionsButton">
            Show dimensions
          </label>
        </div>
      </div>
    )
  }
}

UI.title = 'UI'

export default UI
